import { Form, Input } from 'antd'
import AppDialog from 'components/AppDialog'
import AppLayout from 'components/AppLayout'
import React, { Fragment, useState } from 'react'

const EditableContext = React.createContext<any>({})

const EditableRow = ({ form, index, ...props }: any) => (
	<EditableContext.Provider value={form}>
		<tr {...props} />
	</EditableContext.Provider>
)

const EditableFormRow = Form.create()(EditableRow)

class EditableCell extends React.Component<any, {}> {
	state = {
		editing: false,
	}

	toggleEdit = () => {
		const editing = !this.state.editing
		this.setState({ editing }, () => {
			if (editing) {
				this.input.focus()
			}
		})
	}

	save = (e: any) => {
		const { record, handleSave } = this.props
		this.form.validateFields((error: any, values: any) => {
			if (error && error[e.currentTarget.id]) {
				return
			}
			this.toggleEdit()
			handleSave({ ...record, ...values })
		})
	}

	renderCell = (form: any) => {
		this.form = form
		const { children, dataIndex, record, title } = this.props
		const { editing } = this.state
		return editing ? (
			<Form.Item style={{ margin: 0 }}>
				{form.getFieldDecorator(dataIndex, {
					rules: [
						{
							required: true,
							message: `${title} is required.`,
						},
					],
					initialValue: record[dataIndex],
				})(<Input ref={node => (this.input = node)} onPressEnter={this.save} onBlur={this.save} />)}
			</Form.Item>
		) : (
			<div className="editable-cell-value-wrap" style={{ paddingRight: 24 }} onClick={this.toggleEdit}>
				{children}
			</div>
		)
	}
	input: Input
	form: any

	render() {
		const { editable, dataIndex, title, record, index, handleSave, children, ...restProps } = this.props
		return (
			<td {...restProps}>
				{editable ? <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer> : children}
			</td>
		)
	}
}

export interface Props {
	name?: string
	PageOptionValueField?: string
	PageOptionLabelField?: string
	type?: string
	pageList?: any[]
	PageActionList?: any[]
	buttonType?: string
	openType?: string
	DialogType?: string
	count?: number
	paramlist?: any[]
	action?: string
	page?: string
	width?: number
	height?: number
	callback?: (value: any) => void
}

interface ReturnProps {
	type?: string
	openType?: string
	width?: number
	height?: number
	paramlist?: any[]
	action?: string
	name?: string
	page?: string
	actionType?: string
	pageUrl?: string
	component?: string
	PageOptionLabelField?: string
	PageOptionValueField?: string
}

export const ButtonAction = (props: Props) => {
	const [type, settype] = useState(props.type || 'page')
	const [openType, setopenType] = useState(props.openType || 'self')
	const [DialogType, setDialogType] = useState(props.DialogType || '720*360')
	const [count, setCount] = useState(props.count || 0)
	const [paramlist, setparamlist] = useState(props.paramlist || [])
	const [actionType, setactionType] = useState(props.action || 'null')
	const [Page, setPage] = useState(props.page || 'null')
	const [width, setwidth] = useState(props.width || 360)
	const [height, setheight] = useState(props.height || 720)
	const columns = [
		{
			title: '参数名称',
			dataIndex: 'field',
			width: '30%',
			editable: true,
		},
		{
			title: '参数类型',
			dataIndex: 'type',
			editable: true,
		},
		{
			title: '参数值',
			dataIndex: 'value',
			editable: true,
		},
	]
	const OptionList = [{ label: '打开页面', value: 'page' }, { label: '执行动作', value: 'action' }]
	const ActionList = [
		{ label: '跳转', value: 'self' },
		{ label: '弹出', value: 'dialog' },
		{ label: '滑出', value: 'panel' },
		{ label: '新标签页', value: 'blank' },
	]
	const DialogList = [
		{ label: '720*360', value: '720*360' },
		{ label: '760*600', value: '760*600' },
		{ label: '860*600', value: '860*600' },
		{ label: '960*600', value: '960*600' },
		{ label: '自定义', value: 'other' },
	]
	const components = {
		body: {
			row: EditableFormRow,
			cell: EditableCell,
		},
	}
	const PageActionList = [
		{ label: '无', value: 'null' },
		{ label: '新增行', value: 'Addrow' },
		{ label: '列表保存', value: 'Listsave' },
		{ label: '打印', value: 'print' },
		{ label: '导出', value: 'export' },
		{ label: '保存', value: 'save' },
		{ label: '取消', value: 'close' },
	]
	const close = () => {
		AppDialog.close()
	}
	const handleDialogradio = () => {
		switch (DialogType) {
			case 'other':
				return (
					<div className="app-form">
						{/* <AppInput label='高:' min={1} defaultValue={720} onChange={setheight} value={height} />
          <AppInput label='宽: ' min={1} defaultValue={360} onChange={setwidth} value={width} /> */}
					</div>
				)
			default:
				return <Fragment />
		}
	}
	const handleOpenRadio = () => {
		switch (openType) {
			case 'dialog':
				return (
					<div className="app-form">
						{/* <AppRadio
							label="弹出尺寸:"
							appFormItemOptionList={DialogList}
							onChange={setDialogType}
							value={DialogType}
						/> */}
						{handleDialogradio()}
					</div>
				)
			case 'panel':
				return (
					<div className="app-form">
						{/* <AppLabel label='滑出尺寸:' />
          <AppInput label='宽:' min={1} defaultValue={410} onChange={setwidth} value={width} /> */}
					</div>
				)
			default:
				return <></>
		}
	}
	const handleAdd = () => {
		const newData = {
			key: count,
			field: `测试 ${count}`,
			type: 'any',
			value: `测试 ${count}`,
		}
		setCount(count + 1)
		setparamlist([...paramlist, newData])
	}
	const save = () => {
		let ReturnValue = {} as ReturnProps
		ReturnValue.type = type
		if (type === 'page') {
			ReturnValue.openType = openType
			if (openType === 'dialog') {
				if (DialogType === 'other') {
					ReturnValue.width = width
					ReturnValue.height = height
				} else if (DialogType === '720*360') {
					ReturnValue.width = 360
					ReturnValue.height = 720
				} else if (DialogType === '760*600') {
					ReturnValue.width = 600
					ReturnValue.height = 760
				} else if (DialogType === '860*600') {
					ReturnValue.width = 600
					ReturnValue.height = 860
				} else if (DialogType === '960*600') {
					ReturnValue.width = 600
					ReturnValue.height = 960
				}
			} else if (openType === 'panel') {
				ReturnValue.width = width
			}
			ReturnValue.paramlist = paramlist
			// 1
		} else if (type === 'action') {
			ReturnValue.actionType = actionType

			//
		}
		if (openType === 'self' || openType === 'blank') {
			ReturnValue.pageUrl = Page
		} else if (openType === 'dialog' || openType === 'panel') {
			ReturnValue.component = Page
		}
		ReturnValue.name = 'click'
		props.callback && props.callback(ReturnValue)
		console.log('ReturnValue', ReturnValue)
		AppDialog.close()
		//
	}
	const handleSave = (row: any) => {
		const newData = [...paramlist]
		const index = newData.findIndex((item1: any) => row.key === item1.key)
		const item = newData[index]
		newData.splice(index, 1, {
			...item,
			...row,
		})
		setparamlist(newData)
	}

	const handleOptionRadio = () => {
		const columns1 = columns.map(col => {
			if (!col.editable) {
				return col
			}
			return {
				...col,
				onCell: (record: any) => ({
					record,
					editable: col.editable,
					dataIndex: col.dataIndex,
					title: col.title,
					handleSave,
				}),
			}
		})
		switch (type) {
			// case 'page':
			// 	return (
			// 		<AppLayout.ColFix style={{ overflow: 'auto' }}>
			// 			<div className="app-form">
			// 				{/* <AppInput label="ApiPath"  /> */}
			// 				<AppSelect
			// 					appFormItemOptionList={props.pageList}
			// 					appFormItemOptionLabelField={props.PageOptionLabelField || 'title'}
			// 					appFormItemOptionValueField={props.PageOptionValueField || 'URL'}
			// 					onChange={setPage}
			// 					value={Page}
			// 				/>
			// 				<AppFormRadio
			// 					label="打开方式:"
			// 					appFormItemOptionList={ActionList}
			// 					onChange={setopenType}
			// 					value={openType}
			// 				/>
			// 			</div>
			// 			{handleOpenRadio()}
			// 			<AppMenu>
			// 				<AppRightMenu>
			// 					<AppAction type="primary" action={handleAdd} title="新增参数" />
			// 				</AppRightMenu>
			// 			</AppMenu>
			// 			<Table
			// 				page={page}
			// 				rowClassName={() => 'editable-row'}
			// 				bordered
			// 				dataSource={paramlist}
			// 				columns={columns1}
			// 				className="app-table"
			// 			/>
			// 		</AppLayout.ColFix>
			// 	)
			// case 'action':
			// 	return (
			// 		<AppLayout.ColFix>
			// 			<AppForm colNumber={2}>
			// 				<AppFormSelect
			// 					label="执行动作"
			// 					appFormItemOptionList={props.PageActionList || PageActionList}
			// 					value={actionType}
			// 					onChange={setactionType}
			// 				/>
			// 			</AppForm>
			// 		</AppLayout.ColFix>
			// 	)
			default:
				return <Fragment />
		}
	}
	return (
		<AppLayout mode="col">
			{/* <AppForm>
				<AppFormRadio label="点击行为:" appFormItemOptionList={OptionList} onChange={settype} value={type} />
			</AppForm>
			{handleOptionRadio()}
			<AppFormMenu>
				<AppAction title="保存" type="primary" action={save} />
				<AppAction title="取消" action={close} />
			</AppFormMenu> */}
		</AppLayout>
	)
}



// WEBPACK FOOTER //
// ./src/modules/modeling/page/AppGridLayoutDesiger/ButtonAction.tsx